<template>
  <div class="smy__card-full-box">
    <Card
      :bordered="false"
      class="smy__card-full"
    >
    <p slot="title">
      代理账户查询
    </p>
    <div class="search">
      <!-- 详细筛选条件 -->
      <div>
        <div
          class="search-detail"
        >
        <div class="search-detail-item">
          <Input
          class="search-input"
          placeholder="请输入代理商"
          v-model="searchForm.name"
          ></Input>
        </div>

        <div class="search-detail-item">
          <Input
          class="search-input"
          placeholder="请输入开户行"
          v-model="searchForm.bankName"
          ></Input>
        </div>
        <div class="search-detail-item"
          style="margin-right: 1%;"
          >
          <Input
          class="search-input"
          placeholder="请输入对公账号"
          v-model="searchForm.bankAccount"
          ></Input>
        </div>
        <div class="search-detail-item">
          <Select
            clearable
            filterable
            class="search-input"
            :placeholder="'请选择代理等级'"
            element-id="level"
            v-model="searchForm.level"
          >
            <Option
              v-for="spareType in qdLevel"
              :key="spareType.id"
              :value="spareType.id"
            >{{spareType.name}}</Option>
          </Select>
        </div>
        <div class="search-detail-item">
          <Select
            clearable
            filterable
            class="search-input"
            :placeholder="'请选择是否交保证金'"
            element-id="isPayDeposit"
            v-model="searchForm.isPayDeposit"
          >
            <Option
              v-for="spareType in qdIsPayDeposit"
              :key="spareType.id"
              :value="spareType.id"
            >{{spareType.name}}</Option>
          </Select>
        </div>
        <div class="search-detail-item"
          v-show="user.sysrole !==2"
        >
        <Select
          clearable
          filterable
          class="search-input"
          :placeholder="'请选择渠道经理'"
          element-id="channelId"
          v-model="searchForm.channelId"
        >
          <Option
            v-for="spareType in qdsysrole"
            :key="spareType.id"
            :value="spareType.id"
          >{{spareType.name}}</Option>
        </Select>
        </div>
        <div class="search-detail-item">
          <Button
            type="primary"
            class="search-button"
            @click="loadList"
          >查找</Button>
          <Button
            class="search-button"
            @click="resetSearchForm"
          >重置</Button>
        </div>
        </div>
      </div>
    </div>
    <!-- 工单列表 -->
    <div class="table">
      <Table
        stripe
        ref="table"
        :loading="listLoading"
        :columns="columns"
        :data="list"
      ></Table>
    </div>
    <!-- 分页控件 -->
    <Page
      show-total
      show-sizer
      class="page"
      placement="top"
      :current="pageIndex + 1"
      :total="count"
      :page-size-opts="pageSizeOpts"
      @on-change="pageIndexChange"
      @on-page-size-change="pageSizeChange"
    ></Page>
   </card>
 </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  components: {
  },
  data () {
    return {
      pageSize: 10,
      pageIndex: 0,
      listLoading: false, // 表格加载状态
      count: 0,
      list: [],
      orderId: '',
      qdsysrole: [],
      searchForm: {
        name: '',
        channelId: '',
        bankName: '',
        bankAccount: '',
        level: '',
        isPayDeposit: ''
      },
      qdLevel: [
        {
          id: '0',
          name: '无'
        }, {
          id: '1',
          name: '铜牌'
        },
        {
          id: '2',
          name: '银牌'
        },
        {
          id: '3',
          name: '金牌'
        }
      ],
      qdIsPayDeposit: [
        {
          id: '0',
          name: '否'
        }, {
          id: '1',
          name: '是'
        }
      ]
    }
  },
  computed: {
    ...mapState('table', [
      'columnsCheckedAll',
      'pageSizeOpts'
    ]),
    ...mapState('user', [
      'user'
    ]),
    // 表格列 根据选中的列动态生成
    columns () {
      const allColumns = [
        {
          title: '操作',
          width: 260,
          align: 'center',
          fixed: 'right',
          render: (h, { row }) => {
            let check = h('Button', {
              props: {
                type: 'ghost',
                size: 'small'
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'CheckAccount', params: { orderId: row.id } })
                }
              },
              style: {
              }
            }, ['查看账户'])
            let leven = h('Button', {
              props: {
                type: 'ghost',
                size: 'small'
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'CheckLeven', params: { orderId: row.id } })
                }
              },
              style: {
                marginLeft: '10px'
              }
            }, ['查看等级'])
            let backMoney = h('Button', {
              props: {
                type: 'ghost',
                size: 'small'
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'CheckBackMoney', params: { orderId: row.id } })
                }
              },
              style: {
                marginLeft: '10px'
              }
            }, ['查看返佣'])
            return h('span', [
              check,
              leven,
              backMoney
            ])
          }
        },
        {
          title: '代理商',
          key: 'name',
          width: 140,
          ellipsis: true
        },
        {
          title: '所属渠道经理',
          key: 'channelName',
          width: 140
        },
        {
          title: '开户行',
          key: 'bankName',
          width: 140,
          ellipsis: true
        },
        {
          title: '对公账号',
          key: 'bankAccount',
          width: 160,
          ellipsis: true
        },
        {
          title: '代理等级',
          width: 140,
          render: (h, {row}) => {
            let Type = ''
            if (row.level === 0) {
              Type = '无'
            } else if (row.level === 1) {
              Type = '铜牌'
            } else if (row.level === 2) {
              Type = '银牌'
            } else {
              Type = '金牌'
            }
            return h('span', [Type])
          }
        },
        {
          title: '代理折扣',
          key: 'discount',
          width: 120,
          render: (h, {row}) => {
            let discount = row.discount / 10 + '折'

            return h('span', [discount])
          }
        },
        {
          title: '是否提交保证金',
          key: 'isPayDeposit',
          width: 120,
          render: (h, {row}) => {
            let Type = ''
            if (row.isPayDeposit === 0) {
              Type = '否'
            } else if (row.isPayDeposit === 1) {
              Type = '是'
            }
            return h('span', [Type])
          }
        },
        {
          title: '保证金金额',
          key: 'depositPrice',
          width: 120
        },
        {
          title: '账户余额',
          key: 'accountPrice',
          width: 120,
          ellipsis: true
        },
        {
          title: ' ',
          key: ' '
        }
      ]
      return allColumns
    }
  },
  methods: {
    // 加载列表数据
    loadList () {
      this.listLoading = true
      this.$http.all([
        this.$http.get('/agent/account/list', {
          params: {
            pageIndex: this.pageIndex,
            pageSize: this.pageSize,
            ...this.searchForm
          }
        }),

        this.$http.get('/agent/account/count', {
          params: this.searchForm
        })
      ]).then(this.$http.spread((res1, res2) => {
        this.list = res1.data
        this.count = res2.data
        this.listLoading = false
      }))
    },
    showPicList (index) {
      let arrImg = this.urlImg
      let arr = arrImg.split(',')
      if (arr.length !== 0) {
        arr.forEach((item) => {
          this.picList.push(item)
        })
      }
      this.picIndex = index
      this.picModel = true
    },
    // 分页 每页大小 改变回调
    pageSizeChange (pageSize) {
      this.pageSize = pageSize
      this.loadList()
    },
    // 分页 页码 改变回调
    pageIndexChange (pageIndex) {
      this.pageIndex = pageIndex - 1
      this.loadList()
    },
    // 日期 改变回调
    daterangeChange (daterange, start, end) {
      if (daterange[0]) {
        this.searchForm[start] = daterange[0].replace('/', '-').replace('/', '-')
        this.searchForm[end] = daterange[1].replace('/', '-').replace('/', '-')
      } else {
        this.searchForm[start] = ''
        this.searchForm[end] = ''
      }
      this.emptyORderTime = [this.searchForm[start], this.searchForm[end]]
    },
    // 重置搜索框
    resetSearchForm () {
      this.emptyORderTime = ['', '']
      this.searchForm = {
        title: '',
        balance_state: '',
        invoice_no: '',
        logistics_no: '',
        flow_no: '',
        balance_start_time: '',
        balance_end_time: ''
      }
      this.loadList()
    },
    editReport () {
      this.editReportCurstom = true
    }
  },
  created () {
    this.$http.get('/user/listBySysrole', {
      params: {
        sysrole: 2
      }
    }).then(res => {
      this.qdsysrole = res.data
    })
    this.loadList()
  }
}
</script>

<style lang="less" scoped>
.search {
  margin-bottom: 16px;
  .search-top {
    display: flex;
    justify-content: space-between;

    .search-top-left {
      display: flex;
      width: 70%;

      .search-input {
        width: 80%;

        // margin-left: 10px;
      }

      .search-button {
        margin-left: 10px;
      }
    }

    .search-top-right {
      .filter-column {
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }

      .search-button {
        margin-left: 6px;
      }
    }
  }

  .search-detail {
    display: flex;
    flex-wrap: wrap;
    height: 80px;
    transition: .5s;

    .search-detail-item {
      width: 24.25%;

      .search-input {
        width: 100%;
        margin-bottom: 10px;
      }

      .search-button {
        margin-right: 6px;
      }
    }

    .search-detail-item:nth-child(2n+1),
    .search-detail-item:nth-child(4n+2) {
      margin-right: 1%;
    }
  }

  .search-detail-close {
    height: 0;
    opacity: 0;
  }
}

.page {
  margin-top: 20px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/agentManage/agentAccount/index.vue